// authInitializer.ts
import { useStore } from "@/store/store";

export const initializeAuth = () => {
  const { restoreAuth } = useStore.getState().auth;
  restoreAuth();
};
